module.exports = __webpack_public_path__ + "img/server_down.71cb364f.png";